import Spinner from '~/components/spinner'
import useRetryablePostJSON from '~/hooks/use_retryable_post_json'

export default function ChartBarsInsight({ url, params, title }) {
  const { data, isLoading } = useRetryablePostJSON({ path: url, params })

  return (
    <div className='position-relative h-100 pt-2'>
      {isLoading && <Spinner />}
      {!isLoading && (
        <>
          <h4 className='my-5 text-center'>{title}</h4>
          <br />

          {data.data.map((node) => (
            <div className='text-center' key={node.name}>
              <div className='text-center'>
                <small style={{ color: '#6c757d' }}>{node.name}</small>
              </div>
              <p className='text-center'>
                <span style={{ fontSize: '2.3em' }}>{node.value}</span>
              </p>
            </div>
          ))}
        </>
      )}
    </div>
  )
}
